import { onDocumentEvent } from '@app/utils/domHelpers'
import $ from 'jquery'

const queryAndSubmitByData = (e) => {
  e.preventDefault()
  const formSelector = e.target.dataset.target
  const formElement = document.querySelector(formSelector)

  if (formElement) {
    $(formElement).submit()
  }
}

onDocumentEvent(
  document,
  'mouseup',
  '[data-behaviour="submit-trigger"]',
  queryAndSubmitByData
)
